import { FormHelper } from 'invision-core';
import pathOr from 'ramda/src/pathOr';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import CustomerCareKeys from '../../../../locales/keys';
import { DriversLicenseStateRegionProvinceValueOptions, StateRegionProvinceValueOptions } from '../new.connect.wizard.selectors';
import { CartAdditionalPropertiesSelector, CreatedCustomerSelector, EditCustomerInfoSelector, IsCreatingOrUpdatingCustomerSelector } from '../../../../reducers/selectors/new.connect.wizard.selectors';
import { PreventOverrideFlagSelector } from '../../../../reducers/selectors/customer.addresses.selectors';
import { createCustomerAndSaveOrder, updateCustomerAndSaveOrder, updateCustomerInfoEditCopy } from '../../../../reducers/actions/new.connect.wizard.actions';
import { updateOverrideFlag } from '../../../../reducers/actions/customer.addresses.actions';
import { ShoppingCartSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { getErrorLookupObject } from '../../../createCustomer/create.customer.constants';
import { apFormHasErrors } from '../../../main/customercare.page.helper';
import { clone } from 'ramda';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../../reducers/actions/address.component.actions';
import { EnableProspectLiteSelector } from '../../../../reducers/selectors/customer.selectors';
function SaveOrderController($ngRedux, $state, $timeout, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var popupApi = null;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      addressStates: StateRegionProvinceValueOptions(store),
      cartAdditionalProperties: CartAdditionalPropertiesSelector(store),
      createdCustomer: CreatedCustomerSelector(store),
      driversLicenseStateOptions: DriversLicenseStateRegionProvinceValueOptions(store),
      editCustomerInfo: EditCustomerInfoSelector(store),
      enableProspectLite: EnableProspectLiteSelector(store),
      isCreatingCustomer: IsCreatingOrUpdatingCustomerSelector(store),
      preventOverrideFlag: PreventOverrideFlagSelector(store),
      shoppingCart: ShoppingCartSelector(store),
      unvalidatedAddresses: UnvalidatedAddressesSelector(store),
      validatedAddresses: ValidatedAddressesSelector(store)
    };
  };
  this.$onInit = function () {
    var controllerActions = {
      createCustomerAndSaveOrder: createCustomerAndSaveOrder,
      setForceShowEditFormAddress: setForceShowEditFormAddress,
      updateCustomerAndSaveOrder: updateCustomerAndSaveOrder,
      updateCustomerInfoEditCopy: updateCustomerInfoEditCopy,
      updateOverrideFlag: updateOverrideFlag,
      validateAddress: validateAddress
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.customerCareKeys = CustomerCareKeys;
    _this.showForm = false;
    _this.saveOrderFormErrors = [];

    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.showForm = true;
          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            _this.editCustomerInfoRevertCopy = clone(_this.state.editCustomerInfo);
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
    _this.handleFormChanged = function (customerModel) {
      _this.actions.updateCustomerInfoEditCopy(customerModel);
    };
  };
  this.cancelSaveOrder = function () {
    _this.actions.updateCustomerInfoEditCopy(_this.editCustomerInfoRevertCopy);
    _this.closePopup();
  };
  this.closePopup = function () {
    popupApi.close();
    _this.showForm = false;
  };
  this.onFailure = function (err) {
    var errMessage = err.translatedMessage || err.Message;
    _this.saveOrderFormErrors.push({
      description: errMessage
    });
    uiNotificationService.error(errMessage, null, {
      timeOut: NOTIFICATION_TIME_LENGTH
    });
  };
  this.onSubmitSaveOrderForm = function () {
    var ngFormErrors = _this.formApi.createCustomerForm.$error;
    var saveOrderFormNonApErrors = FormHelper.formHasErrors(ngFormErrors, getErrorLookupObject());
    var apFormErrors = _this.formApi.createCustomerForm.addlApi ? _this.formApi.createCustomerForm.addlApi.$error : null;
    var apErrors = apFormHasErrors(apFormErrors);
    _this.saveOrderFormErrors = saveOrderFormNonApErrors.concat(apErrors);
    if (_this.saveOrderFormErrors.length === 0 && !_this.state.isCreatingCustomer) {
      _this.validateAddressWithAPI().then(function () {
        var addressKey = _this.getAddressKey();
        var validatedAddress = _this.state.validatedAddresses[addressKey];
        if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
          var shoppingCart = _this.state.cartAdditionalProperties.length ? Object.assign({}, _this.state.shoppingCart, {
            AdditionalProperties: _this.state.cartAdditionalProperties
          }) : _this.state.shoppingCart;
          if (!_this.state.createdCustomer) {
            return _this.actions.createCustomerAndSaveOrder(_this.state.editCustomerInfo, shoppingCart, null, null, null, _this.state.preventOverrideFlag).then(function () {
              _this.onSuccess();
              _this.actions.updateOverrideFlag(null);
            }).catch(function (err) {
              _this.onFailure(err);
            });
          } else {
            return _this.actions.updateCustomerAndSaveOrder(_this.state.createdCustomer, _this.state.editCustomerInfo, shoppingCart).then(function () {
              _this.onSuccess();
            }).catch(function (err) {
              _this.onFailure(err);
            });
          }
        }
      }).catch(function (err) {
        _this.onFailure(err);
      });
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.getAddressKey = function () {
    return pathOr(undefined, ['formApi', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], _this);
  };
  this.getAddressKeyForAddressValidatedThroughAPI = function () {
    return pathOr(undefined, ['formApi', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], _this);
  };
  this.getJobToken = function () {
    var addressKey = _this.getAddressKey(),
      addressKeyForAddressValidatedThroughAPI = _this.getAddressKeyForAddressValidatedThroughAPI(),
      validatedAddressForCurrentAddress = _this.state.validatedAddresses[addressKey],
      validatedAddressForAddressValidatedThroughAPI = _this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
    if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
      return validatedAddressForCurrentAddress.JobToken;
    } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
      return validatedAddressForAddressValidatedThroughAPI.JobToken;
    }
    return null;
  };
  this.validateAddressWithAPI = function () {
    var addressKey = _this.getAddressKey(),
      unvalidatedAddress = _this.state.unvalidatedAddresses[addressKey],
      validatedAddress = _this.state.validatedAddresses[addressKey],
      addressTypes = {
        DefaultBilling: true,
        DefaultHome: true,
        DefaultPostal: true,
        DefaultService: true
      };
    if (validatedAddress || !unvalidatedAddress) {
      return Promise.resolve(100);
    } else {
      return _this.actions.validateAddress(addressKey, unvalidatedAddress, _this.getJobToken(), addressTypes);
    }
  };
}
export default {
  template: require('./save.order.popup.html'),
  bindings: {
    config: '<',
    onSuccess: '&'
  },
  controllerAs: 'SaveOrderController',
  controller: SaveOrderController
};